/**
 * Fait : la partie PARTAGER de la fiche projet — ouvrir le projet en lecture à
 *   une personne, par son adresse électronique. Le propriétaire seul la voit,
 *   et c'est l'API qui l'a dit, pas une règle réécrite ici.
 *
 * Ne fait pas : elle n'appelle pas l'API elle-même — le parent le fait et
 *   recharge — et ne crée aucun compte : la personne doit déjà en avoir un.
 */

import { Champ } from '../gabarits/Champ.tsx';
import { Partie } from '../gabarits/Partie.tsx';

export function SectionPartage({
  adresse,
  surAdresse,
  surPartage,
}: {
  readonly adresse: string;
  surAdresse: (adresse: string) => void;
  surPartage: (evenement: React.FormEvent) => void;
}) {
  return (
    <Partie
      etiquette="Ouvrir le projet à quelqu’un"
      nature="partage"
      titre="Partager"
      aide="La personne pourra lire ce projet. Elle doit déjà avoir un compte."
      data-role="partie-partage"
    >
      <form onSubmit={surPartage} data-role="partage">
        <Champ
          libelle="Adresse électronique"
          aide="L’adresse électronique d’un membre de la famille."
          name="adresse-a-partager"
          type="email"
          value={adresse}
          onChange={(evenement) => surAdresse(evenement.target.value)}
        />
        <button type="submit" data-role="principal" disabled={adresse.trim() === ''}>
          Partager en lecture
        </button>
      </form>
    </Partie>
  );
}
